import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';
import { LotDetailsResponse } from '../components/bids-and-offers/lots.model';

@Injectable({
  providedIn: 'root',
})
export class LotDetailsService extends Query<LotDetailsResponse> {
  document = gql`
    query LotDetailsQuery($itemId: String!) {
      lot(id: $itemId) {
        _id
        user_id
        time_frame
        indication
        broker_indication
        market_type
        lot_type
        origin
        commodity
        grade
        product_type
        price {
          __typename
          ... on CashPrice {
            amount
          }

          __typename
          ... on BasisPrice {
            month
            year
            basisPoints
            product_code
          }
        }
        currency
        volume_value
        units
        price_units
        createdAt
        ship_begin
        ship_end
        destination
        delivery_type
        delivery_option
        container_type
        packaging
        tolerance
        payment_term
        specifications {
          title
          value
        }
        documentations {
          title
          value
        }
        additional_info
        rules_to_govern
        weight_grade_to_govern
        status
      }

      user {
        _id
      }

      negotiations {
        _id
        user_id
        lot_user_id
        lot_id
        lot_type
        createdAt

        counters {
          originator_id
          price_value {
            __typename
            ... on CashPrice {
              amount
            }

            __typename
            ... on BasisPrice {
              month
              year
              basisPoints
              product_code
            }
          }
          volume_value
          ship_begin
          ship_end
          created_at
        }

        lot_type
        commodity
        grade
        price_value_orig {
          __typename
          ... on CashPrice {
            amount
          }

          __typename
          ... on BasisPrice {
            month
            year
            basisPoints
            product_code
          }
        }
        currency
        volume_value_orig
        units
        price_units
        ship_begin_orig
        ship_end_orig
        destination
        delivery_type
        container_type
        rules_to_govern
        delivery_option
        status
        lot_market_type
      }
    }
  `;
}
